module.exports = __webpack_public_path__ + "nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf?1c2ecf1e098b735a4a0e421e8ba6518c";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf
// module id = 1341
// module chunks = 33